import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Contextual internal-link block.
 * Drops 3 hand-picked related links into any page to satisfy
 * "every page links to ≥ 3 related pages" for SEO + LLM crawl scaffolding.
 */
export default function ContextualLinks({ title = "Related reading", links = [], testId = "contextual-links" }) {
  if (!links.length) return null;
  return (
    <section className="border-t border-[#2a2620]" data-testid={testId}>
      <div className="max-w-5xl mx-auto px-6 sm:px-8 py-12">
        <p className="font-mono-eav text-[11px] tracking-[0.22em] uppercase text-[#b8963e]">
          {title}
        </p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {links.slice(0, 3).map((l, i) => (
            <Link
              key={i}
              to={l.href}
              data-testid={`${testId}-${i}`}
              className="group p-5 border border-[#2a2620] hover:border-[#b8963e] rounded-sm transition-colors"
            >
              <p className="font-serif-display text-lg text-[#f4efe6] group-hover:text-[#b8963e] transition-colors leading-snug">
                {l.title}
              </p>
              {l.desc && (
                <p className="mt-2 text-sm text-[#c9bca4]">{l.desc}</p>
              )}
              <span className="mt-3 inline-flex items-center gap-1 font-mono-eav text-[10px] tracking-[0.2em] uppercase text-[#b8963e]">
                Read more <ArrowRight className="w-3 h-3" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
